module.exports = __webpack_public_path__ + "fonts/dfadacadb8b225012eee56f4a2e5f951.svg";